export enum ShortcutKey {
    TimeLine = 'KeyT',
    ReservationOverview = 'KeyO',
    Dashboard = 'KeyH',
    NewReservationScreen = 'KeyN',
    NewCustomerScreen = 'KeyG',
    NewCompanyScreen = 'KeyC',
    ResourceStatusReport = 'KeyS',
    CustomLink1 = 'Digit1',
    CustomLink2 = 'Digit2',
    CustomLink3 = 'Digit3',
    CustomLink4 = 'Digit4',
    CustomLink5 = 'Digit5',
    CustomLink6 = 'Digit6',
    CustomLink7 = 'Digit7',
    CustomLink8 = 'Digit8',
    CustomLink9 = 'Digit9',
}

export const CUSTOM_LINK_KEYS = [
    ShortcutKey.CustomLink1,
    ShortcutKey.CustomLink2,
    ShortcutKey.CustomLink3,
    ShortcutKey.CustomLink4,
    ShortcutKey.CustomLink5,
    ShortcutKey.CustomLink6,
    ShortcutKey.CustomLink7,
    ShortcutKey.CustomLink8,
    ShortcutKey.CustomLink9,
] as const;

export const SHORTCUTS_EVENT_CATEGORY = 'Shortcut';
